export const cleanInputArray = (data) => {
  // Handle null or undefined
  if (data === null || data === undefined) {
    return data;
  }

  // Handle arrays - recursively clean each element
  if (Array.isArray(data)) {
    return data.map((item) => cleanInputArray(item)).filter((item) => {
      // Remove null, undefined, or empty objects/arrays after cleaning
      if (item === null || item === undefined || item === "") {
        return false;
      }
      if (Array.isArray(item) && item.length === 0) {
        return false;
      }
      if (typeof item === "object" && Object.keys(item).length === 0) {
        return false;
      }
      return true;
    });
  }

  // Handle objects - recursively clean each property
  if (typeof data === "object") {
    const cleanedObj = {};
    
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const value = data[key];
        
        // Skip null, undefined, or empty strings
        if (value === null || value === undefined || value === "") {
          continue;
        }
        
        // Recursively clean nested objects and arrays
        if (typeof value === "object") {
          const cleanedValue = cleanInputArray(value);
          
          // Only add if the cleaned value is not empty
          if (Array.isArray(cleanedValue)) {
            if (cleanedValue.length > 0) {
              cleanedObj[key] = cleanedValue;
            }
          } else if (cleanedValue !== null && Object.keys(cleanedValue).length > 0) {
            cleanedObj[key] = cleanedValue;
          }
        } else {
          // Add primitive values directly
          cleanedObj[key] = value;
        }
      }
    }
    
    return cleanedObj;
  }

  // Return primitive values as-is
  return data;
};